/**
 * The destinations pinned to the bottom tab bar, in order. The web bar and the
 * native tab bar both read this list so the two cannot disagree about which
 * tabs exist or what they are called.
 */
import { d_chat_bubble, d_folder, d_home, d_more_horiz, d_notifications } from '../../shared/ui/iconPaths';

export type BottomTabId = 'dashboard' | 'projects' | 'messages' | 'notifications' | 'more';

export interface BottomTab {
  id: BottomTabId;
  label: string;
  /** Material Symbols path on the 960 grid. */
  iconPath: string;
}

export const BOTTOM_TABS: readonly BottomTab[] = [
  { id: 'dashboard', label: 'Home', iconPath: d_home },
  { id: 'projects', label: 'Projects', iconPath: d_folder },
  { id: 'messages', label: 'Messages', iconPath: d_chat_bubble },
  { id: 'notifications', label: 'Alerts', iconPath: d_notifications },
  { id: 'more', label: 'More', iconPath: d_more_horiz },
];
